import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import localForage from 'localforage';

// Realtime RTK Slices (Phase 1)
import realtimeUnitReducer from './unitSlice';
import realtimeLastReadingReducer from './lastReadingSlice';
import realtimeDriverReducer from './driverSlice';
import realtimeTagReducer from './tagSlice';
import realtimeAssetReducer from './assetSlice';

import { LOGOUT } from 'Core/containers/Auth/redux/actionTypes';
const CLEAR_REDUX = 'CLEAR_REDUX';

const realtimePersistConfig = {
    key: 'gtc-realtime',
    storage: localForage,
    whitelist: []//['unit', 'lastReading', 'driver', 'tag', 'asset'] // Only persist these specific managed slices
};

const appRealtimeReducer = combineReducers({
    unit: realtimeUnitReducer,
    lastReading: realtimeLastReadingReducer,
    driver: realtimeDriverReducer,
    tag: realtimeTagReducer,
    asset: realtimeAssetReducer,
});

const rootRealtimeReducer = (state, action) => {
    // Clear realtime data automatically only on definitive logout
    if (action.type === LOGOUT || action.type === 'AUTH/LOGOUT') {
        state = undefined;
    }
    // Clear realtime data when CLEAR_REDUX is dispatched with 'REALTIME' as payload
    if (action.type === CLEAR_REDUX && action.payload?.option === 'REALTIME') {
        state = undefined;
    }
    
    return appRealtimeReducer(state, action);
};

// Export persisted slices as a single tree 'realtime'
export default {
    realtime: persistReducer(realtimePersistConfig, rootRealtimeReducer)
};
